import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { clear } from "@testing-library/user-event/dist/clear";

import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";

const AddWorkShopCoupon = () => {
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    //const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid')
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [workShopCategory, setWorkShopCategory] = useState('');
    const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
    const [selectedWorkShop, setSelectedWorkShop] = useState('');
    const [selectedValue, setSelectedValue] = useState('percentage');


    const [addWorkShopCouponForm, setAddWorkShopCouponForm] = useState({
        event_name: eventName,
        w_workshop_coupon_name: "",
        w_workshop_code: "",
        descriptions: "",
        w_workshop_coupon_value_fixed: "",
        w_workshop_coupon_percentage: "",

        error_list: [],
    });

    useEffect(() => {
        axios.get(`api/workshop-category-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wcategoryData = res.data.workshopCategories;
                setWorkShopCategoryData(wcategoryData);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);

    const [workshopCoupon, setworkshopCoupon] = useState([]);

    useEffect(() => {
        axios.get(`api/workshop-coupon-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.workshopCoupen;
                setworkshopCoupon(wksp);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');

            }


        });

    }, []);
    const [assignCategoye, setAssignCategoye] = useState([]);
    const handleChangeMulti = (event: SelectChangeEvent<typeof assignCategoye>) => {
        const {
            target: { value },
        } = event;

        if (value.includes("selectAll")) {
            // If "Select All" is selected and not all items are currently selected, select all.
            // If all items are already selected, unselect all.
            setAssignCategoye(
                assignCategoye.length !== workshopCoupon.length
                    ? workshopCoupon.map((workshop) => workshop.id)
                    : []
            );
        } else {
            // Update assignCategoye based on individual selections
            setAssignCategoye(
                // On autofill we get a stringified value.
                typeof value === "string" ? value.split(",") : value
            );
        }
    };


    // const handleCheckboxChange = () => {
    //     setChecked(!isChecked);
    // };





    const [prefix, setPrefix] = useState('');
    const [count, setCount] = useState(0);
    const [generatedCoupons, setGeneratedCoupons] = useState([]);

    useEffect(() => {
        const generateCoupons = () => {
            const coupons = [];
            const uniqueCodes = new Set();

            while (coupons.length < count) {
                const randomCode = generateRandomCode();
                const couponCode = `${prefix}${randomCode}`;

                if (!uniqueCodes.has(couponCode)) {
                    uniqueCodes.add(couponCode);
                    coupons.push(couponCode);
                }
            }

            setGeneratedCoupons(coupons);
        };

        generateCoupons();
    }, [prefix, count]);

    const generateRandomCode = () => {
        return Math.random().toString(36).substring(2, 8).toUpperCase();
    };









    const handleInput = (e) => {
        e.persist();
        setAddWorkShopCouponForm({ ...addWorkShopCouponForm, [e.target.name]: e.target.value });
    }



    const handleChange = (event) => {
        setSelectedWorkShop(event.target.value);
    };
    const handleChangeSelectAmountType = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleStartTime = (event) => {
        setStartTime(event.target.value);
    };

    const handleEndTime = (event) => {
        setEndTime(event.target.value);
    };



    const handleDateChange = (event) => {
        setSelectedDate(event.target.value);
    };

    const handleWorkShopCategory = (e) => {
        setWorkShopCategory(e.target.value);
    }

    const submitWorkShop = (e) => {

        e.preventDefault();

        const data = {
            eventid,
            event_name: addWorkShopCouponForm.event_name,
            w_workshop_coupon_name: addWorkShopCouponForm.w_workshop_coupon_name,

            w_workshop_coupon_percentage: addWorkShopCouponForm.w_workshop_coupon_percentage,
            w_workshop_coupon_value_fixed: addWorkShopCouponForm.w_workshop_coupon_value_fixed,
            descriptions: addWorkShopCouponForm.descriptions,
            expireDate: selectedDate,
            coupon_codes: generatedCoupons,
            coupon_apply_workshop: selectedWorkShop,
            amount_type: selectedValue,
            prefix,
            coupon_qty: count,




        }
        console.clear();
        console.log(data)
        //   data.title == "" ? setdisabled(false) :
        //       data.descriptions == "" ? setdisabled(false) :
        //           setdisabled(true)

        axios.get('/sanctum/csrf-cookie').then(response => {

            axios.post(`/api/workshop-create-coupon-store`, data).then(res => {

                if (res.data.status === 200) {


                    swal('Success', res.data.message, 'success');

                    history.push('/admin/workshop/manage-coupon');
                }
                else {

                    setAddWorkShopCouponForm({ ...addWorkShopCouponForm, error_list: res.data.validate_error })

                }

            });


        });


    }
    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        marginTop: '2%',
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'
                        onClick={() => history.goBack()}>
                        Back
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Add WorkShop Coupon
                        </Typography>
                        <Box component="form" onSubmit={submitWorkShop} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>
                                <Grid item xs={6} >
                                    <TextField
                                        disabled
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="Evnet Name"
                                        autoFocus
                                        name='event_name' onChange={handleInput}
                                        defaultValue={eventName || ""}
                                    />
                                </Grid>


                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="WorkShop Coupon Name"
                                        autoFocus
                                        name='w_workshop_coupon_name' onChange={handleInput}
                                    />
                                </Grid>


                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Amount Type</InputLabel>
                                        <Select
                                            label="Amount Type"
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={selectedValue}
                                            onChange={handleChangeSelectAmountType}
                                        >
                                            <MenuItem value="percentage">Percentage</MenuItem>
                                            <MenuItem value="fixed">Fixed</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                {selectedValue === 'percentage' && (
                                    <Grid item xs={6}>
                                        {/* Render input for percentage */}
                                        <TextField
                                            autoComplete="given-name"
                                            required
                                            fullWidth
                                            label=" Coupon Value Percentage"
                                            autoFocus
                                            name="w_workshop_coupon_percentage"
                                            onChange={handleInput}
                                        />
                                    </Grid>

                                )}

                                {selectedValue === 'fixed' && (
                                    <Grid item xs={6}>
                                        {/* Render input for amount */}
                                        <TextField
                                            autoComplete="given-name"
                                            required
                                            fullWidth
                                            label="Coupon Value Fixed"
                                            autoFocus
                                            name="w_workshop_coupon_value_fixed"
                                            onChange={handleInput}
                                        />
                                    </Grid>
                                )}




                                <Grid item xs={12} >

                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth

                                        label="Add Descriptions"
                                        autoFocus
                                        name='descriptions' onChange={handleInput}
                                        multiline
                                        rows={6}
                                    />

                                </Grid>
                                <Grid item xs={6}>

                                    <FormControl fullWidth>
                                        <InputLabel id="select-label">Select Workshop</InputLabel>
                                        <Select
                                            labelId="select-label"
                                            id="select"
                                            value={selectedWorkShop}
                                            label="Select Workshop"
                                            onChange={handleChange}
                                        >
                                            {workshopCoupon.map((item) => (
                                                <MenuItem key={item.id} value={item.id}>{item.workshop_name}</MenuItem>
                                            ))}

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        id="date"
                                        fullWidth
                                        label="Expire Date"
                                        type="date"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>



                                <Grid item xs={6}>

                                    <TextField
                                        fullWidth
                                        label="Coupon Prefix"
                                        variant="outlined"
                                        inputProps={{ maxLength: 3 }}
                                        value={prefix}
                                        onChange={(e) => setPrefix(e.target.value)}
                                        style={{ marginRight: '10px' }}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        label="Number of Coupons"
                                        variant="outlined"
                                        type="number"
                                        inputProps={{ min: 0 }}
                                        value={count}
                                        onChange={(e) => {
                                            const maxLength = 2;
                                            const value = e.target.value.slice(0, maxLength);
                                            setCount(value);
                                        }}
                                        style={{ marginRight: '10px' }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="h6" style={{ marginTop: '20px' }}>
                                        Generated Coupons:
                                    </Typography>
                                    <ul>
                                        {generatedCoupons.map((coupon, index) => (
                                            <li key={index}>{coupon}</li>
                                        ))}
                                    </ul>
                                </Grid>



                            </Grid>

                            <Grid container justifyContent="flex-end">
                                <Button
                                    disabled={disabled}
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: '#145348', }} >
                                    Add WorkShop coupon
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </div >
    );
}

export default AddWorkShopCoupon;
